const INITIAL_STATE = {
  activitiesList: [],
  activitiesWithSubactivities: [],
};

const activitiesReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_ACTIVITIES':
    if (action.error) return state;
    return { ...state, activitiesList: action.data };
  case 'GET_SUB_ACTIVITIES':
    if (action.error) return state;
    return { ...state, subActivitiesList: action.data };

  case 'GET_ACTIVITIES_WITH_SUB_ACTIVITIES':
    if (action.error) return state;
    return { ...state, activitiesWithSubactivities: action.data.data };

  default:
    return state;
  }
};

export default activitiesReducer;
